.articleViewerPage {
    visibility: visible;
}
